import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const cddrcp8590 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_CoolingDegreeDays/MapServer/0",
    title: 'Cooling Degree Days Change until 2090',
    opacity: 0.4,
    oraId: 'cddrcp8590',
  })